module.exports = __webpack_public_path__ + "static/mountainwest-097ae146dbb4001a959cb96145576ca8.png";